<div *ngIf="tag()" class="guide-home-container container">
  <div class="row">
    <div class="col">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs()"></app-breadcrumbs>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h1
        class="guide-list-header my-6 text-3xl font-bold text-grey-1 md:text-4xl"
        id="guide-header"
      >
        {{ tag().name }}
      </h1>

      <div class="page-content narrowed-content text-center">
        <div [innerHTML]="tag().description | safeHtml"></div>
      </div>

      <div class="small-puffs-list">
        <app-guide-puffs-list [puffs]="guidePosts()"></app-guide-puffs-list>

        <app-ui-button
          (onClick)="loadMore()"
          *ngIf="isMoreBtnVisible()"
          [color]="'green'"
          [compressed]="false"
          [expanded]="'inline'"
          [size]="'lg'"
          class="more-btn"
        >
          Ladda mer
        </app-ui-button>
      </div>
    </div>
  </div>
</div>
